import appConfig from '../config/appConfig.json'
import * as FileSaver from "file-saver";

export function exportToCSV(locale, schools,offeringSorts,gradeFilters,searchedPlace) {
    let searchPlace = "\n";
    let selectOfferings = ""; 
    let selectGrades = ""

    let gradeHeader = "For the following Grades: ";
    let programHeader = "Programs: ";
    let programField = "label";

    // translate to spanish if appropriate
    if (locale === "es") {
        gradeHeader = "Para los siguientes grados: ";
        programHeader = "Programas: ";
        programField = "es";
    }

    // selected offerings
    if (gradeFilters.length > 0)
    {
      selectGrades = gradeHeader;
      gradeFilters.forEach(grades => {
        selectGrades += grades.replace(/_/g, "").toUpperCase() + "|";
      })
      selectGrades = selectGrades.substr(0, selectGrades.lastIndexOf("|")) + "\n";     
    }

    if (offeringSorts.length > 0)
    {
      selectOfferings = programHeader;
      offeringSorts.forEach(offerings => {
        selectOfferings += offerings[programField] + "|";
      })
      selectOfferings = selectOfferings.substr(0, selectOfferings.lastIndexOf("|")) + "\n";     
    }

    // searched address/place
    if (searchedPlace !== null)
    {
      searchPlace = searchedPlace.properties.FullAddress + "\n";
    }

    let csvHeader = appConfig.csvHeader;
    
    const fileName = "msdc_export.csv"    
    let data = [];

    schools.forEach(school => {
      data.push({
        name: '"' + school.properties.name + '"',
        website: school.properties.schoolInfo.website,
        address: school.properties.addressInfo.address,
        city: school.properties.addressInfo.city,
        zip: school.properties.addressInfo.zip,
        state: school.properties.addressInfo.state,
        ward:  school.properties.addressInfo.ward,
        feederSchool: school.properties.feederSchool != null ? '"' + school.properties.feederSchool+ '"' : "",
        grades_served: school.properties.grades_served.length > 1 ?  school.properties.grades_served[0].replace("_","").toUpperCase() + " to " + school.properties.grades_served[school.properties.grades_served.length - 1 ].replace("_","").toUpperCase() : school.properties.grades_served[0].replace("_","").toUpperCase(),
        metro_bus_service: school.properties.metro_bus_service,
        metro_rail_service: school.properties.metro_rail_service != null ? '"' + school.properties.metro_rail_service + '"' : "",
        alert_message: school.properties.alert_message != null ? '"' + school.properties.alert_message + '"' : "",
        distance:  school.distance,
        rank:  school.rank,
        before_care:  school.properties.offerings.includes('before_care')? "Yes" : "No",
        after_care:  school.properties.offerings.includes('after_care')? "Yes" : "No",
        uniform:  school.properties.offerings.includes('uniform')? "Yes" : "No",
        advanced_placement:  school.properties.offerings.includes('advanced_placement')? "Yes" : "No",
        arts_integration:  school.properties.offerings.includes('arts_integration')? "Yes" : "No", 
        blended_learning:  school.properties.offerings.includes('blended_learning')? "Yes" : "No", 
        career_and_technical_education:  school.properties.offerings.includes('career_and_technical_education')? "Yes" : "No", 
        dual_college_enrollment:  school.properties.offerings.includes('dual_college_enrollment')? "Yes" : "No", 
        dual_language_language_immersion:  school.properties.offerings.includes('dual_language_language_immersion')? "Yes" : "No",
        extended_day:  school.properties.offerings.includes('extended_day')? "Yes" : "No",
        extended_year:  school.properties.offerings.includes('extended_year')? "Yes" : "No", 
        international_baccalaureate2:  school.properties.offerings.includes('international_baccalaureate2')? "Yes" : "No", 
        interscholastic_sports:  school.properties.offerings.includes('interscholastic_sports')? "Yes" : "No", 
        jrotc:  school.properties.offerings.includes('jrotc')? "Yes" : "No",
        montessori:  school.properties.offerings.includes('montessori')? "Yes" : "No", 
        online_learning:  school.properties.offerings.includes('online_learning')? "Yes" : "No", 
        restorative_justice:  school.properties.offerings.includes('restorative_justice')? "Yes" : "No",
        school_gardens:  school.properties.offerings.includes('school_gardens')? "Yes" : "No", 
        selective_program:  school.properties.offerings.includes('selective_program')? "Yes" : "No", 
        single_gender_campus:  school.properties.offerings.includes('single_gender_campus')? "Yes" : "No", 
        stem_focus:  school.properties.offerings.includes('stem_focus')? "Yes" : "No",
        offering_mets:   school.offeringMets===null? 0 : school.offeringMets.metCount,
        inBoundary_ES:  school.properties.inBoundary === true && school.rank === "ES" ? "In-Boundary Elementary School" : "",
        inBoundary_MS:  school.properties.inBoundary === true && school.rank === "MS" ? "In-Boundary Middle School" : "",
        inBoundary_HS:  school.properties.inBoundary === true && school.rank === "HS" ? "In-Boundary High School" : "",
      })
    });

    const csvString = [
      csvHeader,
      ...data.map(item => [
        item.name, item.address, item.website, 
        item.city, item.state, item.zip, 
        item.grades_served, 
        item.inBoundary_ES + item.inBoundary_MS + item.inBoundary_HS,
        item.feederSchool, item.distance, item.ward, item.metro_rail_service,
        Array.isArray(item.metro_bus_service) ? '"'+ item.metro_bus_service.join(", ") + '"' : "" , 
        item.alert_message, item.before_care, item.after_care, item.uniform, item.advanced_placement, 
        item.arts_integration, item.blended_learning, item.career_and_technical_education, 
        item.dual_college_enrollment, item.dual_language_language_immersion, item.extended_day,
        item.extended_year, item.international_baccalaureate2, item.interscholastic_sports, item.jrotc,
        item.montessori, item.online_learning, item.single_gender_campus,item.stem_focus, 
        item.selective_program, item.restorative_justice, item.school_gardens, item.offering_mets
      ])
    ]
    .map(e => e.join(",")) 
    .join("\n");

    const data1 = new Blob([searchPlace + selectOfferings + selectGrades + "\n" +  csvString], {
      type: "text/csv;charset=utf-8"     
    });  // NOTE:  without Blob just as plain csvString var as text giving network error look into this

    FileSaver.saveAs(data1, fileName);    
}